import Intl from 'intl';
import 'intl/locale-data/jsonp/pt-BR';
import IMask from 'imask';

export function getBRCurrencyFormat(value = 0, withSpace = false) {
  let result = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);

  if (!withSpace) {
    result = result.replace(/^(\D+)/, '$1 ');
  }

  return result;
}

const cellphoneMask = IMask.createMask({ mask: [{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }] });

export const UserFormatter = {
  getFormattedPhone(cellphone = '') {
    return cellphoneMask.resolve(cellphone);
  },
};
